import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InputForm } from "../../_helpers/components/Forms/InputLabel";
import toast from "react-hot-toast";
import { Button } from "../../_helpers/components/Button";
import { RedirectLink } from "../../_helpers/components/RedirectLink";
import { LoginAccount } from "../../_api/Admin";
import logo from "../../../../../public/imgs/logo.png";
import { resolveLoginLanding } from "../../_helpers/resolveLoginLanding";
import axios from "axios";
import { test } from "../../Layout/ClientDescription";

const Login = (props) => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const hostname = window.location.hostname;
    const sub_domain = hostname.split(".")[0];

    const onKeyUp = (event) => {
        if (event.key === "Enter") {
            const element = document.getElementById("buttonLogin");
            element.click();
            signIn();
        }
    };

    useEffect(() => {
        setEmail(localStorage.getItem("MAIL_CONNEXION"));
    }, []);

    // Connexion request
    const signIn = async (e) => {
        setError(null);
        e?.preventDefault();
        if (!password) {
            setError("S'il vous plait, mettez un mot de passe.");
        }
        if (!email) {
            setError("Il faut remplir un email.");
        } else {
            setLoading(true);
            axios.get("/sanctum/csrf-cookie").then((response) => {
                LoginAccount({ email, password })
                    .then(({ data }) => {
                        props.setUser(data);
                        setError(null);
                        localStorage.setItem("MAIL_CONNEXION", email);
                        navigate(resolveLoginLanding(data));
                    })
                    .catch((err) => {
                        const message = err?.response?.data?.message ?? "Erreur inconnue";
                        toast(message);
                    }).finally(() => {
                        setLoading(false)
                    });
            });
        }
    };

    return (
        <>
            <div className="w-full lg:w-1/2 flex justify-center items-center">
                <div className="bg-white p-4 rounded-lg shadow-md w-3/4 max-w-md">
                    <div className="lg:hidden w-full h-48 mb-4">
                        <img
                            src={test[sub_domain]?.logo || logo}
                            alt="Logo"
                            onClick={() => navigate("/")}
                            className="w-full h-full mx-auto object-contain cursor-pointer"
                        />
                    </div>
                    <div className="space-y-4">
                        <InputForm
                            name="Email"
                            value={email}
                            set={setEmail}
                            placeholder={"example.nom@domaine.fr"}
                            required={true}
                            autoComplete="email"
                        />

                        {/* Champ mot de passe avec toggle */}
                        <div className="relative">
                            <InputForm
                                type={showPassword ? "text" : "password"}
                                onKeyUp={onKeyUp}
                                name="Mot de passe"
                                value={password}
                                set={setPassword}
                                placeholder={"**********"}
                                required={true}
                                id="password"
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-11 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                            >
                                {showPassword ? (
                                    // Icône oeil barré (hide password)
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 15.598 7.244 19.5 12 19.5c1.674 0 3.26-.354 4.684-.987M21 12c-1.292-3.598-5.31-7.5-10.066-7.5-1.674 0-3.26.354-4.684.987M3 3l18 18"
                                        />
                                    </svg>
                                ) : (
                                    // Icône oeil normal (show password)
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.364 4.5 12 4.5c4.636 0 8.577 3.01 9.964 7.183.07.207.07.431 0 .639C20.577 16.49 16.636 19.5 12 19.5c-4.636 0-8.577-3.01-9.964-7.178z"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>

                        <div className="flex justify-between">
                            {/* {test[sub_domain] ? (
                                <RedirectLink
                                    to="/enregistrement"
                                    name="S'inscrire"
                                />
                            ) : (
                                <RedirectLink
                                    to="/register"
                                    name="Pas encore inscrit ?"
                                />
                            )} */}
                            {test[sub_domain] && (
                                <RedirectLink
                                    to="/enregistrement"
                                    name="S'inscrire"
                                />
                            )}

                            <RedirectLink
                                to="/demande-mot-de-passe"
                                name="Mot de passe oublié ?"
                            />
                        </div>
                        {error && (
                            <p className="text-left text-red-500 text-xs italic">
                                {error}
                            </p>
                        )}
                        <div className="flex justify-end">
                            <Button
                                action={(e) => { if (loading) return; signIn(e) }}
                                name="Se connecter"
                                id={"buttonLogin"}
                                loading={loading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
